exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".daily-report-table[data-v-d2582298],.daily-report-table>*[data-v-d2582298]{width:100%}", ""]);

// exports
